import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function AirplaneFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15 4.99983C15.8683 4.13161 17.684 2.39192 18.5 1.93536C19.5637 1.3403 20.6279 1.2262 21.8101 1.93536C21.9157 1.99869 22.004 2.08703 22.0674 2.19258C22.7865 3.3909 22.6687 4.45404 22.0674 5.51451C21.608 6.3248 19.8663 8.13352 19 8.99979L17.5 10.4999L20.2887 17.6359C20.5387 18.5857 20.2653 19.5968 19.5708 20.2912L18.7542 21.1075C18.594 21.2676 18.3701 21.3468 18.1449 21.3229C17.9197 21.2991 17.7173 21.1747 17.5943 20.9846L13 14.5L10 17.5L10.5686 20.4943C10.5937 20.7207 10.5146 20.9464 10.3534 21.1075L8.93104 22.5296C8.76057 22.7 8.51857 22.7781 8.28062 22.7395C8.04268 22.7009 7.8378 22.5503 7.72997 22.3347L5.7082 18.292L1.66465 16.2706C1.44899 16.1628 1.29831 15.9579 1.25969 15.7199C1.22107 15.4819 1.29923 15.2398 1.46973 15.0694L2.89211 13.6473C3.05321 13.4862 3.27878 13.4071 3.5052 13.4323L6.5 14L9.5 11.0001L3.01501 6.40809C2.82482 6.28505 2.70043 6.08264 2.67656 5.85738C2.6527 5.63212 2.73192 5.40814 2.89211 5.24799L3.70872 4.43165C4.40325 3.73726 5.41436 3.46399 6.36415 3.71389L13.5 6.50003L15 4.99983Z"
				fill="currentColor"
			/>
		</svg>
	);
}

AirplaneFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default AirplaneFilledIcon;
